module.exports = __webpack_public_path__ + "files/9ca8677fda79a391202cdcd61652956f.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-96x96.png
// module id = 570
// module chunks = 60